/*
  "Showing 9 of 23" under collection and search grids (snippets/product-grid.liquid).
  Horizon adds more cards as the shopper scrolls and swaps the grid when filters change;
  this counts the cards in the results list and updates the text and the bar.
*/
class VirasatGridProgress extends HTMLElement {
  /** @type {MutationObserver | null} */
  #observer = null;

  connectedCallback() {
    const list = this.closest('results-list') || this.parentElement;
    if (!list) return;

    this.#observer = new MutationObserver(() => this.#update(list));
    this.#observer.observe(list, { childList: true, subtree: true });
    this.#update(list);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }

  /** @param {Element} list */
  #update(list) {
    const total = Number(this.dataset.total) || 0;
    const shown = Math.min(total, list.querySelectorAll('.product-grid__item').length);

    const text = (this.dataset.template || '').replace('[shown]', String(shown));
    const label = this.querySelector('.v-grid-progress__text');
    if (label && label.textContent !== text) label.textContent = text;

    const bar = this.querySelector('.v-grid-progress__bar > span');
    if (bar instanceof HTMLElement) bar.style.width = total ? `${Math.round((shown / total) * 100)}%` : '0%';
  }
}

if (!customElements.get('v-grid-progress')) {
  customElements.define('v-grid-progress', VirasatGridProgress);
}
